import Noty from 'noty';
import Vue from 'vue';

Vue.use({
  install(Vue, options) {
    Noty.overrideDefaults({
      layout: 'bottomRight',
      theme: 'metroui',
      timeout: 5000,
    });

    const showAndReturn = options => {
      const notification = new Noty(options);
      notification.show();
      return notification;
    };

    Vue.prototype.$notification = Noty;
    Vue.prototype.$notifySuccess = (message, options = {}) => showAndReturn({
      text: `<i class="zmdi zmdi-check"></i> ${message}`,
      type: 'success',
      ...options,
    });

    Vue.prototype.$notifyFailure = (message, options = {}) => showAndReturn({
      text: `<i class="zmdi zmdi-close"></i> ${message}`,
      type: 'error',
      ...options,
    });

    Vue.prototype.$notifyConfirm = (message, options = {}) => showAndReturn({
      modal: true,
      timeout: false,
      type: 'alert',
      killer: true,
      closeWith: ['button'],
      text: `<i class="zmdi zmdi-info-outline"></i> ${message}`,
      ...options,
    });
  },
});
